"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iter = exports.rangeIter = exports.ChainableIterator = void 0;
var errors_1 = require("./errors");
var maybe_1 = require("./maybe");
/**
 * Represents a chainable iterator that allows performing various operations on an underlying generator.
 *
 * @typeParam T - The type of elements produced by the iterator.
 */
var ChainableIterator = /** @class */ (function () {
    function ChainableIterator(generator) {
        this.generator = generator;
    }
    /**
     * Creates a new {@link ChainableIterator} from a generator factory function.
     *
     * ?> Use {@link iter} rather than calling raw constructor functions
     */
    ChainableIterator.fromGeneratorFn = function (factory) {
        return new ChainableIterator(factory());
    };
    /**
     * Creates a new {@link ChainableIterator} from an existing iterator
     *
     * ?> Use {@link iter} rather than calling raw constructor functions
     */
    ChainableIterator.fromIter = function (iter) {
        return ChainableIterator.fromGeneratorFn(function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [5 /*yield**/, __values((_a = {}, _a[Symbol.iterator] = function () { return iter; }, _a))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a new {@link ChainableIterator} from an array's internal iterator
     *
     * ?> Use {@link iter} rather than calling raw constructor functions
     */
    ChainableIterator.fromArr = function (arr) {
        return ChainableIterator.fromIter(arr[Symbol.iterator]());
    };
    ChainableIterator.prototype.return = function () {
        return this.generator.return();
    };
    ChainableIterator.prototype.throw = function (e) {
        return this.generator.throw(e);
    };
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    ChainableIterator.prototype[Symbol.iterator] = function () {
        return this.generator[Symbol.iterator]();
    };
    /**
     * Returns the next value from the iterator.
     *
     * @param args - Optional arguments that will be passed to the underlying generator's `next()` method.
     * @returns An object representing the next value and done status of the iterator.
     *
     * @example
     * ```typescript
     * const chainableIterator = ChainableIterator.from<number>(() => [1, 2, 3][Symbol.iterator]());
     * const firstValue = chainableIterator.next();
     * console.log(firstValue); // Output: { value: 1, done: false }
     * ```
     */
    ChainableIterator.prototype.next = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.generator).next.apply(_a, __spreadArray([], __read(args), false));
    };
    /**
     * Applies a transformation function to each element of the iterator.
     *
     * @typeParam U - The type of elements produced by the resulting iterator after applying the mapping function.
     * @param func - The mapping function that transforms elements from type `T` to type `U`.
     * @returns A new `ChainableIterator` with elements of type U.
     *
     * @example
     * ```typescript
     * const chainableIterator = ChainableIterator.from<number[]>(() => [[1, 2], [3, 4], [5, 6]]);
     * const flattenedIterator = chainableIterator.map((arr) => arr.reduce((acc, val) => acc + val, 0));
     * const result = flattenedIterator.collect();
     * console.log(result); // Output: [3, 7, 11]
     * ```
     */
    ChainableIterator.prototype.map = function (func) {
        var generator = this.generator;
        return ChainableIterator.fromGeneratorFn(function () {
            var idx, generator_1, generator_1_1, val, e_1_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        idx = 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        generator_1 = __values(generator), generator_1_1 = generator_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!generator_1_1.done) return [3 /*break*/, 5];
                        val = generator_1_1.value;
                        return [4 /*yield*/, func(val, idx++)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        generator_1_1 = generator_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (generator_1_1 && !generator_1_1.done && (_a = generator_1.return)) _a.call(generator_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Filters the elements of the iterator based on a predicate function.
     *
     * @param func - The predicate function used to filter the elements.
     * @returns A new `ChainableIterator` containing only the elements that satisfy the predicate.
     * @example
     * ```typescript
     * function arrIsOnlyEvens(arr) {
     *   return arr.every(val => val % 2 == 0);
     * }
     *
     * const iter = ChainableIterator.from(() => [[1, 2], [3, 4], [5, 6]]);
     * const result = iter.filter(arrIsOnlyEvens).collect();
     * console.log(result); // Output: [[3, 4], [5, 6]]
     * ```
     */
    ChainableIterator.prototype.filter = function (func) {
        var generator = this.generator;
        return ChainableIterator.fromGeneratorFn(function () {
            var generator_2, generator_2_1, val, e_2_1;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        generator_2 = __values(generator), generator_2_1 = generator_2.next();
                        _b.label = 1;
                    case 1:
                        if (!!generator_2_1.done) return [3 /*break*/, 4];
                        val = generator_2_1.value;
                        if (!func(val)) return [3 /*break*/, 3];
                        return [4 /*yield*/, val];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        generator_2_1 = generator_2.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (generator_2_1 && !generator_2_1.done && (_a = generator_2.return)) _a.call(generator_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reduces the elements of the iterator to a single value using the provided reducer function.
     *
     * @param func - The reducer function used to combine the elements.
     * @returns The final reduced value.
     *
     * @example
     * ```ts
     * const iter = ChainableIterator.fromArr([[1], [2], [3], [4], [5]]);
     * const result = iter.reduce((acc, arr) => acc.concat(arr), []);
     * console.log(result); // Output: [1, 2, 3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.reduce = function (func) {
        var _this = this;
        var _a;
        var _next = function (val) {
            var next = _this.generator.next();
            if (next.done)
                return val;
            else
                return _next(func(val, next.value));
        };
        return _next((_a = this.generator.next().value) !== null && _a !== void 0 ? _a : (0, errors_1.throwError)("Cannot reduce an empty iterator"));
    };
    /**
     * Folds the elements of the iterator with an initial value and a reducer function.
     *
     * @typeParam U - The type of the resulting folded value.
     * @param initialValue - The initial value of the fold.
     * @param func - The reducer function used to combine the elements.
     * @returns The final folded value.
     *
     * @example
     * ```ts
     * const iter = ChainableIterator.fromArr([[1], [2], [3], [4], [5]]);
     * const result = iter.fold("## ", (acc, arr) => acc + arr[0]);
     * console.log(result); // Output: "## 12345"
     * ```
     */
    ChainableIterator.prototype.fold = function (initialValue, func) {
        var _this = this;
        var _next = function (val) {
            var next = _this.generator.next();
            if (next.done)
                return val;
            else
                return _next(func(val, next.value));
        };
        return _next(initialValue);
    };
    /**
     * Takes a specific number of elements from the iterator and returns a new iterator with those values
     *
     * @param count - The number of elements to take from the iterator.
     * @returns A new `ChainableIterator` containing the taken elements.
     *
     * @example
     * ```ts
     * const iter = ChainableIterator.fromArr([1, 2, 3, 4, 5]);
     * const result = iter.take(3).collect();
     * console.log(result); // Output: [1, 2, 3]
     * ```
     */
    ChainableIterator.prototype.take = function (count) {
        var generator = this.generator;
        function _take(num) {
            var next;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        next = generator.next();
                        if (!!next.done) return [3 /*break*/, 2];
                        return [4 /*yield*/, next.value];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(!next.done && num > 1)) return [3 /*break*/, 4];
                        return [5 /*yield**/, __values(_take(num - 1))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }
        return new ChainableIterator(_take(count));
    };
    /**
     * Collects all elements of the iterator into an array.
     *
     * ?> This is the equivalent of using the `[...iter]` syntax;
     *
     * @returns An array containing all elements of the iterator in the order they were produced.
     *
     * @example
     * ```ts
     * const result = iter([1, 2, 3, 4, 5]).collect();
     * console.log(result); // Output: [1, 2, 3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.collect = function () {
        return __spreadArray([], __read(this.generator), false);
    };
    ChainableIterator.prototype.count = function () {
        return this.collect().length;
    };
    /**
     * Returns the last element of the iterator.
     *
     * @returns The last element produced by the iterator.
     *
     * @example
     * ```ts
     * const result = iter([1, 2, 3, 4, 5]).last();
     * console.log(result); // Output: 5
     * ```
     */
    ChainableIterator.prototype.last = function () {
        return this.reduce(function (_, val) { return val; });
    };
    /**
     * Retrieves the nth element from the iterator (zero-based index).
     *
     * @param n - The zero-based index of the element to retrieve.
     * @returns The nth element as a {@link}. If the index is out of range, it returns `null`.
     *
     * @example
     * ```ts
     * const element = iter([1, 2, 3, 4, 5]).nth(2);
     * console.log(element); // Output: 3
     * ```
     */
    ChainableIterator.prototype.nth = function (n) {
        var _this = this;
        var _a;
        rangeIter(0, n - 1).forEach(function () { return _this.next(); });
        return (0, maybe_1.intoMaybe)((_a = this.next().value) !== null && _a !== void 0 ? _a : null);
    };
    /**
     * Chains the elements of the current iterator with the elements of another iterator.
     *
     * @typeParam U - The type of elements produced by the other iterator.
     * @param other - Another {@link ChainableIterator} to chain with the current iterator.
     * @returns A new {@link ChainableIterator} containing elements from both iterators in sequence.
     *
     * @example
     * ```ts
     * const result = iter([1, 2, 3]).chain(iter(4, 5, 6)).collect()
     * console.log(result); // Output: [1, 2, 3, 4, 5, 6]
     * ```
     */
    ChainableIterator.prototype.chain = function (other) {
        var generator = this.generator;
        return ChainableIterator.fromGeneratorFn(function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [5 /*yield**/, __values(generator)];
                    case 1:
                        _a.sent();
                        return [5 /*yield**/, __values(other.generator)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Zips the elements of the current iterator with the elements of another iterator.
     *
     * @typeParam U - The type of elements produced by the other iterator.
     * @param other - Another `ChainableIterator` to zip with the current iterator.
     * @returns A new `ChainableIterator` containing pairs of elements from both iterators until the shortest iterator is exhausted.
     *
     * @example
     * ```ts
     * const iter1 = iter([1, 2, 3])
     * const iter2 = iter([4, 5, 6]);
     * const result = iter1.zip(iter2).collect();
     * console.log(result); // Output: [[1, 4], [2, 5], [3, 6]]
     * ```
     */
    ChainableIterator.prototype.zip = function (other) {
        var generator = this.generator;
        return ChainableIterator.fromGeneratorFn(function () {
            var generator_3, generator_3_1, a, _a, b, done, e_3_1;
            var e_3, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, 6, 7]);
                        generator_3 = __values(generator), generator_3_1 = generator_3.next();
                        _c.label = 1;
                    case 1:
                        if (!!generator_3_1.done) return [3 /*break*/, 4];
                        a = generator_3_1.value;
                        _a = other.next(), b = _a.value, done = _a.done;
                        if (!!done) return [3 /*break*/, 3];
                        return [4 /*yield*/, [a, b]];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        generator_3_1 = generator_3.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_3_1 = _c.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (generator_3_1 && !generator_3_1.done && (_b = generator_3.return)) _b.call(generator_3);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Executes a provided function on each element of the iterator.
     *
     * @param func - The function to execute on each element.
     *
     * @example
     * ```typescript
     * iter([1, 2, 3, 4, 5]).forEach((val) => console.log(val)); // Output: 1, 2, 3, 4, 5
     * ```
     */
    ChainableIterator.prototype.forEach = function (func) {
        var e_4, _a;
        try {
            for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
                var val = _c.value;
                func(val);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    /**
     * Maps the elements of the iterator using a mapping function that returns a {@link Maybe} value and filters out the `null` values.
     *
     * @typeParam U - The type of elements produced after applying the mapping function.
     * @param func - The mapping function that returns a `Maybe` value.
     * @returns A new `ChainableIterator` containing the mapped and filtered elements.
     *
     * @example
     * ```ts
     * function divideByTwo(val: number): Maybe<number> {
     *   if (val % 2 == 0) return val / 2;
     *   return null;
     * }
     *
     * const result = iter([1, 2, 3, 4, 5]).filterMap(divideByTwo).collect();
     * console.log(result); // Output: [1, 2]
     * ```
     */
    ChainableIterator.prototype.filterMap = function (func) {
        return this.map(func).filter(maybe_1.isSome);
    };
    /**
     * Enumerates the elements of the iterator, providing their index along with the value.
     *
     * @returns A new `ChainableIterator` containing pairs of index-value for each element.
     *
     * @example
     * ```ts
     * const result = iter([10, 20, 30, 40, 50]).enumerate().collect();
     * console.log(result); // Output: [[0, 10], [1, 20], [2, 30], [3, 40], [4, 50]]
     * ```
     */
    ChainableIterator.prototype.enumerate = function () {
        return this.map(function (val, idx) { return [idx, val]; });
    };
    /**
     * Skips elements from the iterator while the provided predicate function returns `true`.
     *
     * @param func - The predicate function used to determine whether to skip elements.
     * @returns A new {@link ChainableIterator} containing the remaining elements after skipping.
     *
     * @example
     * ```ts
     * function isEven(val: number): boolean {
     *   return val % 2 == 0;
     * }
     *
     * const result = iter([4, 2, 3, 2, 4]).skipWhile(isEven).collect();
     * console.log(result); // Output: [3, 2, 4]
     * ```
     */
    ChainableIterator.prototype.skipWhile = function (func) {
        return ChainableIterator.fromGeneratorFn(function () {
            var skipping, _a, _b, val, e_5_1;
            var e_5, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        skipping = true;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, 9, 10]);
                        _a = __values(this), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 7];
                        val = _b.value;
                        if (!!skipping) return [3 /*break*/, 4];
                        return [4 /*yield*/, val];
                    case 3:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!!func(val)) return [3 /*break*/, 6];
                        skipping = false;
                        return [4 /*yield*/, val];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_5_1 = _d.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        }.bind(this));
    };
    /**
     * Takes elements from the iterator while the provided predicate function returns `true`.
     *
     * @param func - The predicate function used to determine whether to take elements.
     * @returns A new {@link ChainableIterator} containing elements taken until the predicate returns `false`.
     *
     * @example
     * ```ts
     * function isLessThanThree(val: number): boolean {
     *   return val < 3;
     * }
     *
     * const nums = iter([1, 2, 3, 4, 5]);
     * console.log(nums.takeWhile(isLessThanThree).collect()); // [1, 2]
     * console.log(nums.collect()) // [3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.takeWhile = function (func) {
        return ChainableIterator.fromGeneratorFn(function () {
            var _a, _b, val, e_6_1;
            var e_6, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = __values(this), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        val = _b.value;
                        if (!func(val))
                            return [2 /*return*/];
                        return [4 /*yield*/, val];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }.bind(this));
    };
    /**
     * Maps the elements of the iterator while the provided mapping function returns a non-null value, and stops when a `null` value is encountered.
     *
     * @typeParam U - The type of elements produced after applying the mapping function.
     * @param func - The mapping function that returns a {@link Maybe} value.
     * @returns A new {@link ChainableIterator} containing the mapped elements until a `null` value is encountered.
     *
     * @example
     * ```ts
     * function maybeDivideByTwo(val: number): Maybe<number> {
     *   if (val % 2 == 0) return val / 2;
     *   return null;
     * }
     *
     * const iter = ChainableIterator.from<number[]>(() => [2, 4, 6, 7, 8]);
     * const result = iter([2, 4, 6, 7, 8]).mapWhile(maybeDivideByTwo).collect();
     * console.log(result); // Output: [1, 2, 3]
     * ```
     */
    ChainableIterator.prototype.mapWhile = function (func) {
        return ChainableIterator.fromGeneratorFn(function () {
            var _a, _b, val, mapped, e_7_1;
            var e_7, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = __values(this), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        val = _b.value;
                        mapped = func(val);
                        if ((0, maybe_1.isNone)(mapped))
                            return [2 /*return*/];
                        return [4 /*yield*/, mapped];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_7_1 = _d.sent();
                        e_7 = { error: e_7_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_7) throw e_7.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }.bind(this));
    };
    /**
     * Skips a specific number of elements from the iterator by calling `[Symbol.iterator].next()` `n` times
     *
     * @param n - The number of elements to skip.
     *
     * @example
     * ```
     * const result = iter([1, 2, 3, 4, 5]).skip(2).collect();
     * console.log(result); // Output: [3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.skip = function (n) {
        if (n == 0)
            return this;
        this.next();
        return this.skip(n - 1);
    };
    /**
     * Scans the elements of the iterator using a reducer function and returns a new iterator with intermediate values.
     *
     * @typeParam U - The type of elements produced after applying the reducer function.
     * @param initialValue - The initial value of the scan.
     * @param func - The reducer function used to combine the elements.
     * @returns A new {@link ChainableIterator} containing intermediate scan values.
     *
     * @example
     * ```ts
     * iter([1, 2, 3, 4, 5])
     *   .scan(0, (acc, val) => acc + val)
     *   .inspect(console.log) // Output 1 3 6 10 15
     *   .scan(0, (acc, val) => acc + val)
     *   .inspect(console.log); // Output 1 4 10 20 35
     * ```
     */
    ChainableIterator.prototype.scan = function (initialValue, func) {
        return ChainableIterator.fromGeneratorFn(function () {
            var state, _a, _b, val, e_8_1;
            var e_8, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        state = initialValue;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _a = __values(this), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        val = _b.value;
                        state = func(state, val);
                        return [4 /*yield*/, state];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_8_1 = _d.sent();
                        e_8 = { error: e_8_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }.bind(this));
    };
    /**
     * Flattens the elements of the iterator by unwrapping nested arrays.
     *
     * @returns A new {@link ChainableIterator} with elements at the deepest level of nesting.
     *
     * @example
     * ```ts
     * const result = iter([[1], [2, 3], [4, 5, 6]]).flatten().collect();
     * console.log(result); // Output: [1, 2, 3, 4, 5, 6]
     * ```
     */
    ChainableIterator.prototype.flatten = function () {
        return ChainableIterator.fromGeneratorFn(function () {
            var _a, _b, val, e_9_1;
            var e_9, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 7, 8, 9]);
                        _a = __values(this), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 6];
                        val = _b.value;
                        if (!Array.isArray(val)) return [3 /*break*/, 3];
                        return [5 /*yield**/, __values(ChainableIterator.fromArr(val))];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, val];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_9_1 = _d.sent();
                        e_9 = { error: e_9_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_9) throw e_9.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }.bind(this));
    };
    /**
     * Maps and flattens the elements of the iterator using a mapping function.
     *
     * @typeParam U - The type of elements produced after applying the mapping function.
     * @param func - The mapping function that returns an array of values.
     * @returns A new {@link ChainableIterator} containing the mapped and flattened elements.
     *
     * @example
     * ```ts
     * const result = iter([1, 2, 3]).flatMap((val) => [val, val * 2]).collect();
     * console.log(result); // Output: [1, 2, 2, 4, 3, 6]
     * ```
     */
    ChainableIterator.prototype.flatMap = function (func) {
        return this.map(func).flatten();
    };
    /**
     * Executes a provided function on each element of the iterator and returns a new iterator with the original elements.
     *
     * @param func - The function to execute on each element.
     * @returns A new `ChainableIterator` containing the original elements.
     *
     * @example
     * ```ts
     * const iter = ChainableIterator.from<number[]>(() => [1, 2, 3, 4, 5]);
     * const result = iter([1, 2, 3, 4, 5]).inspect(console.log).collect();
     * // Output: 1, 2, 3, 4, 5
     * console.log(result); // Output: [1, 2, 3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.inspect = function (func) {
        return this.map(function (val) {
            func(val);
            return val;
        });
    };
    /**
     * Partitions the elements of the iterator into two new iterators based on a predicate function.
     *
     * @param func - The predicate function used to determine the partitioning.
     * @returns A tuple of two {@link ChainableIterator} instances: one containing elements that satisfy the predicate, and the other containing elements that don't.
     *
     * @example
     * ```typescript
     * function isEven(val: number): boolean {
     *   return val % 2 === 0;
     * }
     *
     * const iter = ChainableIterator.from<number[]>(() => [1, 2, 3, 4, 5]);
     * const [evenIter, oddIter] = iter.partition(isEven);
     * console.log(evenIter.collect()); // Output: [2, 4]
     * console.log(oddIter.collect()); // Output: [1, 3, 5]
     * ```
     */
    ChainableIterator.prototype.partition = function (func) {
        var _a = __read(this.fold([[], []], function (_a, val) {
            var _b = __read(_a, 2), arr1 = _b[0], arr2 = _b[1];
            if (func(val))
                return [arr1.concat([val]), arr2];
            else
                return [arr1, arr2.concat([val])];
        }), 2), a = _a[0], b = _a[1];
        return [ChainableIterator.fromArr(a), ChainableIterator.fromArr(b)];
    };
    /**
     * Checks if all elements of the iterator satisfy a given predicate.
     *
     * @param func - The predicate function used to determine if elements satisfy the condition.
     * @returns `true` if all elements satisfy the predicate, otherwise `false`.
     *
     * @example
     * ```ts
     * function isPositive(val: number): boolean {
     *   return val > 0;
     * }
     *
     * const result = iter([1, 2, 3, 4, 5]).every(isPositive);
     * console.log(result); // Output: true
     * ```
     */
    ChainableIterator.prototype.every = function (func) {
        var e_10, _a;
        try {
            for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
                var val = _c.value;
                if (!func(val))
                    return false;
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return true;
    };
    /**
     * Removes duplicate elements from the iterator.
     *
     * This method returns a new {@link ChainableIterator} with duplicate elements removed.
     *
     * @returns A new ChainableIterator with duplicate elements removed.
     *
     * @example
     * ```typescript
     * const result = iter([1, 2, 3, 4, 5, 1, 2, 3, 4, 5]).dedup().collect();
     * console.log(result); // [1, 2, 3, 4, 5]
     * ```
     */
    ChainableIterator.prototype.dedup = function () {
        var generator = this.generator;
        var vals = [];
        return ChainableIterator.fromGeneratorFn(function () {
            var _a, _b, val, e_11_1;
            var e_11, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = __values(generator), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        val = _b.value;
                        if (vals.includes(val))
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, val];
                    case 2:
                        _d.sent();
                        vals.push(val);
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_11_1 = _d.sent();
                        e_11 = { error: e_11_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_11) throw e_11.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return ChainableIterator;
}());
exports.ChainableIterator = ChainableIterator;
/**
 * @generator
 *
 * Generates a range of numbers from a lower bound to an optional upper bound.
 *
 * !> Note: When providing bounds of a very large interval, this generator may result in stack overflow errors due to excessive recursion.
 *
 *
 * @param {number} lower - The lower bound of the range.
 * @param {number} upper - The upper bound of the range (inclusive).
 * @returns {Generator<number>} A generator yielding the numbers in the specified range.
 *
 * @example
 * ```ts
 * for (const i of rangeIter(-5, 10)) {
 *  console.log(i); // -5, -4, -3, -2, ... 9, 10
 * }
 * ```
 *
 * @category Iterator
 */
function rangeIter(lower, upper) {
    return iter(function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lower];
                case 1:
                    _a.sent();
                    if (!(lower < upper)) return [3 /*break*/, 3];
                    return [5 /*yield**/, __values(rangeIter(lower + 1, upper))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.rangeIter = rangeIter;
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function iter(val) {
    if (typeof val == "function")
        return ChainableIterator.fromGeneratorFn(val);
    if (Array.isArray(val))
        return ChainableIterator.fromArr(val);
    else
        return ChainableIterator.fromIter(val);
}
exports.iter = iter;
